// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-2fd2e700] .v-tabs-items{background-color:transparent!important}.v-tabs[data-v-2fd2e700] .v-tabs-slider-wrapper{display:block!important}", ""]);
// Exports
module.exports = exports;
